<template>
	<th
		v-if="header.condition ? header.condition() : true"
		:colspan="header.properties?.colCount ?? 1"
		:width="typeof header.width === 'number' ? `${header.width}px` : 'unset'"
		:class="[
			header.properties?.onSort ? 'sortable' : '',
			sortedColumnModel === header.model ? sortOrder : '',
			header.width !== undefined && typeof header.width !== 'number'
				? `column-width-${header.width}`
				: '',
		]"
		@click="$emit('sort')"
		@keydown.space="$emit('sort')"
	>
		<div class="table-cell-wrap">
			<h2 v-if="header.properties?.isTitle" class="app-card-title">
				{{ header.label }}
			</h2>
			<div v-else class="table-cell-flex" tabindex="0">
				<span class="column-name icon-container">{{ header.label }}</span>
				<span class="column-value">{{ value }}</span>
			</div>
		</div>
	</th>
</template>

<script setup lang="ts" generic="T">
import type { SortOrder } from "@/enums/SortOrder";
import type { AppCardTableHeaderModel } from "@/models/AppCardTableHeaderModel";

defineProps<{
	header: AppCardTableHeaderModel<T>;
	sortedColumnModel?: string;
	sortOrder?: SortOrder;
	value?: string | number;
}>();

defineEmits<{
	sort: [];
}>();
</script>

<style lang="scss">
@use "@/style/mixins.scss" as mixins;

th {
	&.column-width-fill {
		width: auto;
	}

	.table-cell-wrap {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.column-name {
			width: 100%;
			text-align: left;
		}
	}
}
</style>
